import * as React from 'react';
import {
  bindHover,
  bindMenu,
  usePopupState,
  anchorRef,
} from 'material-ui-popup-state/hooks';
import { IconButton } from '../BasicButtons/IconButton';
import { Icon } from '../BasicIcons/FontAwesome';
import HoverMenu from 'material-ui-popup-state/HoverMenu';
import { ReactActionsProps } from '.';
import { useStyles } from './useStyles';
import { StyledMenuItem } from './StyledMenuItem';
import { useTheme } from '@material-ui/core';

export const HoverActions = React.forwardRef<any, ReactActionsProps>(
  function HoverActions(props, ref) {
    const { id, items, size, iconVariant } = props;
    const classes = useStyles();
    const popupState = usePopupState({
      variant: 'popover',
      popupId: id,
    });
    const theme = useTheme();
    const buttons = items.filter(a => a !== undefined);
    return (
      <React.Fragment>
        <div ref={anchorRef(popupState)} className={classes.root}>
          <IconButton
            aria-label={id}
            variant={iconVariant || 'ghost'}
            shape="square"
            size={size}
            {...bindHover(popupState)}
          >
            <Icon icon="ellipsis-v" />
          </IconButton>
          <HoverMenu
            ref={ref}
            {...bindMenu(popupState)}
            anchorOrigin={{ vertical: 'center', horizontal: 'right' }}
            transformOrigin={{ vertical: 'top', horizontal: 'left' }}
            getContentAnchorEl={undefined}
            {...props}
          >
            {buttons.map((item, index) => {
              return (
                <StyledMenuItem
                  key={index}
                  ref={ref}
                  theme={theme}
                  button={false}
                  onClick={() => popupState.close()}
                  {...props}
                >
                  {item}
                </StyledMenuItem>
              );
            })}
          </HoverMenu>
        </div>
      </React.Fragment>
    );
  },
);
